import { defineStore } from "pinia";
import { ref, computed } from "vue";
import axios from "@/plugins/axios";
import { showMessage } from "@/utils/notifications";

export const useRoleStore = defineStore("role", () => {
  // State
  const roleList = ref([]);

  // Getters
  const getRoleList = computed(() => roleList.value);

  // Actions
  const setRoleList = (data) => {
    roleList.value = data;
  };

  const addRole = (data) => {
    for (var i = 0; i < roleList.value.length; i++) {
      if (roleList.value[i].entity_id == data.entity_id) {
        roleList.value[i] = data;
        return;
      }
    }
    roleList.value.push(data);
  };

  const deleteRole = (payload) => {
    let index = roleList.value.findIndex((e) => e.entity_id == payload.entity_id);
    if (index > -1) {
      roleList.value.splice(index, 1);
    }
  };

  // API Actions
  const getRoles = async () => {
    try {
      const response = await axios.get(`/role`);
      const resData = response.data;

      if (!resData.success) {
        showMessage({ ...resData, messageType: "error", messageTitle: "Error" });
        return resData;
      } else {
        setRoleList(resData.roles);
        return resData;
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      return { success: false, message: "Failed to fetch roles" };
    }
  };

  const addRoleAction = async (payload) => {
    try {
      const { data } = await axios.post(`/role`, {
        role_type: payload.role_type,
        person_id: payload.person_id,
        investor_id: payload.investor_id,
        entity_id: payload.entity_id,
        version: payload.version,
      });

      if (!data.success) {
        showMessage({ ...data, messageType: "error", messageTitle: "Error" });
        return data;
      }

      showMessage({ ...data, messageType: "success", messageTitle: "Success" });
      addRole(data.role);
      return true;
    } catch (error) {
      console.error("Error adding role:", error);
      return { success: false, message: "Failed to add role" };
    }
  };

  const deleteRoleAction = async (payload) => {
    try {
      const { data } = await axios.delete("/role", {
        data: {
          entity_id: payload.entity_id,
        },
      });

      if (!data.success) {
        showMessage({ ...data, messageType: "error", messageTitle: "Error" });
        return data;
      }

      showMessage({ ...data, messageType: "success", messageTitle: "Success" });
      deleteRole(payload);
      return true;
    } catch (error) {
      console.error("Error deleting role:", error);
      return { success: false, message: "Failed to delete role" };
    }
  };

  return {
    // State
    roleList,

    // Getters
    getRoleList,

    // Actions
    setRoleList,
    addRole,
    deleteRole,

    // API Actions
    getRoles,
    addRoleAction,
    deleteRoleAction,
  };
});
